module.exports = __webpack_public_path__ + "static/media/4.96d4e3b0.png";